import { API_SUPPLIER_CONFIGURABLES } from "../../utils/apis";
import { getRegister } from "../../utils/helpers";
import { URL_SUPPLIER_CONFIGURABLES } from "../../utils/urls";

export const useSupplierConfigurablesForm = () => {
  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "name",
          type: "text",
          label: "Supplier Name",
          props: { required: true },
        },
        {
          field_name: "description",
          type: "textarea",
          label: "Description",
          props: { required: true },
        },
        {
          field_name: "contact_person_name",
          type: "name",
          label: "Contact Person Name",
          props: { required: true },
        },
        {
          field_name: "phone_number",
          type: "tel",
          label: "Phone Number",
          props: { required: true },
        },
        {
          field_name: "email",
          type: "text",
          label: "Email Address",
          props: { required: true },
        },
        {
          field_name: "physical_address",
          type: "text",
          label: "Physical Address",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_SUPPLIER_CONFIGURABLES);

  return {
    sections,
    redirect,
  };
};

export function submitSupplierConfigurables(payload: any, id: string) {
  //  on update
  if (id) {
    return {
      id,
      api: API_SUPPLIER_CONFIGURABLES,
      params: payload,
    };
  }
  // on create
  return {
    api: API_SUPPLIER_CONFIGURABLES,
    params: payload,
  };
}
